<template>
  <div class="animated revealUp">
    <div class="section-title mb-3">{{ $t("add") }} {{ $t("invoice") }}</div>
    <section class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 2) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in Cinemas"
                  :key="cinemaIndex"
                  v-on:click="onSelectCinema(cinema)"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <!-- <Tooltip :title="$t('invoice_selectCinema')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedCinema.length == 0"
              >Please Select Cinema.</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedVendor.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("vendor", 1) }}</label
              >
              <b-dropdown
                :text="selectedVendor"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Vendor"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchVendor()"
                    v-on:keydown="onSearchVendor()"
                    v-on:search="onSearchVendor()"
                    v-model="searchVendor"
                  />
                </div>
                <b-dropdown-item
                  v-for="(vendor, vendorKey) in Vendors"
                  :key="vendorKey"
                  v-on:click="onSelectVendor(vendor)"
                  >{{ vendor.v_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <!-- <Tooltip :title="$t('purchaseOrder_selectVendor')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedVendor.length == 0"
              >Please Select Vendor.</span
            >
          </p>
        </div>

        <!-- <div class="col-md-12 mb-3 font-weight-bold">{{ $t("items") }}</div> -->
        <section v-if="true" class="mb-4 w-100 px-3 section-new">
          <div
            class="section-title mb-3 d-flex justify-content-between section-collapse-box"
            style="
              padding: 6px;
              align-items: center;
              border: 1px solid lightgray;
              border-radius: 10px;
            "
            v-b-toggle.goodreturnform
          >
            <span class="fs">
              {{ $tc("Item", 2) }}
            </span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <b-collapse
            id="goodreturnform"
            class="mt-2"
            v-model="sectionCollapse.goodreturnform"
            style="border: 1px solid lightgray; border-radius: 10px"
          >
            <div
              class="col-12 mb-4 border-bottom"
              :key="vendorIndex"
              v-for="(item, vendorIndex) in RawMaterialsList"
            >
              <div class="row mt-2">
                <div class="col-md-11 mb-2 border-right">
                  <div class="row">
                    <div class="col-md-3">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            v-model="item.rm_name"
                            type="text"
                            name="rmname"
                            id="rmname"
                            v-validate="'required'"
                            placeholder="."
                          />
                          <label>{{ $t("item") }} {{ $t("name") }}</label>
                        </div>
                        <!-- <img
                      src="@/assets/img/icons/question.svg"
                      height="20"
                      width="20"
                      class="ml-2"
                      v-b-tooltip.hover
                      :title="'Enter Item Name'"
                    /> -->
                      </div>
                      <p class="error_message">
                        <span v-if="submitted && errors.has('rmname')">{{
                          errors.first("rmname")
                        }}</span>
                      </p>
                    </div>

                    <div class="col-md-3">
                      <div class="d-flex align-items-center">
                        <b-input-group>
                          <b-form-input
                            v-model="item.ii_qty"
                            style="
                              height: 40px;
                              border-top-left-radius: 10px;
                              border-bottom-left-radius: 10px;
                              text-align: right;
                            "
                            type="number"
                            placeholder="Qty"
                          ></b-form-input>

                          <template v-slot:append>
                            <b-dropdown variant="dropdown-curve" class="w-100">
                              <b-dropdown-item
                                v-for="(loop, key) in 500"
                                :key="key"
                                v-on:click="onSelectQuantity(loop, vendorIndex)"
                                >{{ loop }}</b-dropdown-item
                              >
                            </b-dropdown>
                          </template>
                        </b-input-group>
                        <!-- <Tooltip :title="$t('purchaseOrder_Quantity')" /> -->
                      </div>
                      <p class="error_message">
                        <span v-if="submitted && item.ii_qty.length == 0"
                          >Please select or enter quantity.</span
                        >
                      </p>
                    </div>

                    <!-- <div class="col-lg-3">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label :class="item.uom_unit.length > 0 ? 'shift-up' : ''">{{ $t('select') }} UOM</label>
                  <b-dropdown :text="item.uom_unit" variant="dropdown-curve" class="w-100">
                    <b-dropdown-item
                      v-for="(measurement , measurementkey) in measurements"
                      :key="measurementkey"
                      v-on:click="onSelectUom(measurement,vendorIndex)"
                    >{{ measurement.uom_unit }}</b-dropdown-item>
                  </b-dropdown>
                </div>
                <Tooltip :title="$t('purchaseOrder_selectUOM')" />
              </div>
              <p class="error_message">
                <span v-if="submitted && item.uom_unit.length == 0">Please Select UOM.</span>
              </p>
                </div>-->

                    <div class="col-md-3">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            v-model="item.ii_price"
                            @input="calcTotal(vendorIndex)"
                            type="number"
                            name="invoicenetamount"
                            id="invoicenetamount"
                            v-validate="'required|decimal'"
                            placeholder="."
                          />
                          <label>{{ $t("netAmount") }}</label>
                        </div>
                        <!-- <Tooltip :title="$t('invoic_netamount')" /> -->
                      </div>
                      <p class="error_message">
                        <span
                          v-if="submitted && errors.has('invoicenetamount')"
                          >{{ errors.first("invoicenetamount") }}</span
                        >
                      </p>
                    </div>

                    <div class="col-md-3">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            v-model="item.ii_tax_amount"
                            @input="calcTotal(vendorIndex)"
                            type="number"
                            name="taxamount"
                            id="taxamount"
                            v-validate="'required|decimal'"
                            placeholder="."
                          />
                          <label>{{ $t("taxamount") }}</label>
                        </div>
                        <!-- <Tooltip :title="$t('invoice_taxamount')" /> -->
                      </div>
                      <p class="error_message">
                        <span v-if="submitted && errors.has('taxamount')">{{
                          errors.first("taxamount")
                        }}</span>
                      </p>
                    </div>

                    <div class="col-md-3">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            v-model="item.ii_total_amount"
                            type="text"
                            name="totalrate"
                            id="totalrate"
                            v-validate="'required|decimal'"
                            placeholder="."
                          />
                          <label>{{ $t("totalamount") }}</label>
                        </div>
                        <!-- <Tooltip :title="$t('purchaseOrder_TotalAmount')" /> -->
                      </div>
                      <p class="error_message">
                        <span v-if="submitted && errors.has('totalrate')">{{
                          errors.first("totalrate")
                        }}</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-1 d-flex align-items-center justify-content-center"
                >
                  <button
                    v-if="vendorIndex == 0"
                    @click.prevent.stop="addVendor(vendorIndex)"
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/plus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                  <button
                    v-else
                    @click.prevent.stop="removeVendor(vendorIndex)"
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/minus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                </div>
              </div>
            </div>
          </b-collapse>
        </section>
        <!-- end -->
        <div class="col-lg-6 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="InvoiceDetails.i_date"
                  v-on:click="clearSelectedDate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="InvoiceDetails.i_date"
                  name="invociedate"
                  id="invoicedate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label
                  :class="
                    InvoiceDetails.i_date &&
                    typeof InvoiceDetails.i_date === 'object'
                      ? 'active'
                      : ''
                  "
                  >{{ $t("invoiceorderdate") }}</label
                >
              </div>
            </div>
            <!-- <Tooltip :title="$t('purchaseOrder_PurchaseOrderDate')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('invoicedate')">{{
              errors.first("invoicedate")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                style="text-align: right"
                placeholder="."
                type="number"
                v-model="InvoiceDetails.i_total_amount"
                name="totalamount"
                id="totalamount"
                v-validate="'required|decimal'"
              />
              <label>{{ $tc("totalamount", 2) }}</label>
            </div>
            <!-- <Tooltip :title="$t('purchaseOrder_TotalAmount')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('totalamount')">{{
              errors.first("totalamount")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-2 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("invoiceorderlock") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="InvoiceDetails.i_lock"
              type="checkbox"
              class="j-checkbox ml-2"
              checked
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="InvoiceDetails.i_is_active"
              type="checkbox"
              class="j-checkbox ml-2"
              checked
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 mb-4 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit()"
            class="btn-blue"
          >
            {{ $t("save") }}</button
          >&nbsp;
          <router-link to="invoice" class="btn-outline-blue">{{
            $t("cancel")
          }}</router-link>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";

export default {
  data() {
    return {
      //ii means InvoiceItem
      isRoleID: true,
      btenable: false,
      submitted: false,
      InvoiceDetails: {
        cinema_id: "",
        v_id: "",
        i_date: new Date(),
        i_total_amount: 0,
        i_lock: false,
        i_is_active: true,
      },
      RawMaterialsList: [
        {
          rm_name: "",
          i_quantity: "",
          ii_qty: "",
          uom_unit: "",
          uom_id: "",
          i_total_amount: "",
        },
      ],
      Cinemas: [],
      CinemasCopy: [],
      searchCinema: "",
      RawMaterials: [],
      Vendors: [],
      VendorsCopy: [],
      searchVendor: "",
      measurements: [],
      selectedCinema: "",
      selectedVendor: "",
      selectedQuantity: "",
      selectedUom: "",
      sectionCollapse: {
        goodreturnform: true,
      },
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemasList(obj);
  },
  mounted() {
    this.getVendorsList();
    this.getunitsofmeasurements();
  },
  methods: {
    calcTotal(index) {
      this.RawMaterialsList[index].ii_total_amount =
        (this.RawMaterialsList[index].ii_price
          ? parseFloat(this.RawMaterialsList[index].ii_price)
          : 0) +
        (this.RawMaterialsList[index].ii_tax_amount
          ? parseFloat(this.RawMaterialsList[index].ii_tax_amount)
          : 0);
      let total = 0;
      this.RawMaterialsList.map((x) => {
        total += x.ii_total_amount;
      });
      this.InvoiceDetails.i_total_amount = total;
    },
    clearSelectedDate: function () {
      this.InvoiceDetails.i_date = "";
    },
    onSearchVendor: function () {
      if (this.searchVendor && this.searchVendor.length > 0) {
        this.Vendors = this.VendorsCopy.filter((x) => {
          if (
            x.v_name.toLowerCase().includes(this.searchVendor.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Vendors = this.VendorsCopy;
      }
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemasList: function (cine_id) {
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                this.onSelectCinema(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getunitsofmeasurements: function () {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.measurements = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getVendorsList: function () {
      let payload = {
        tableName: "ms_vendors",
        v_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Vendors = data.Records;
            this.VendorsCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },

    onSelectCinema: function (params) {
      this.selectedCinema = params.cine_name;
      this.InvoiceDetails.cinema_id = params.cine_id;
      this.searchCinema = "";
      this.onSearchCinema();
    },

    onSelectVendor: function (params) {
      this.selectedVendor = params.v_name;
      this.InvoiceDetails.v_id = params.v_id;
      this.searchVendor = "";
      this.onSearchVendor();
    },

    onSelectQuantity: function (params, index) {
      this.RawMaterialsList[index]["ii_qty"] = params.toString();
    },

    onSelectUom: function (params, index) {
      this.RawMaterialsList[index].uom_unit = params.uom_unit;
      this.RawMaterialsList[index].uom_id = params.uom_id;
    },
    addVendor: function () {
      this.RawMaterialsList.push({
        rm_name: "",
        ii_price: "",
        ii_tax_amount: "",
        ii_total_amount: "",
        ii_qty: "",
        uom_unit: "",
        uom_id: "",
      });
    },
    removeVendor: function (index) {
      this.RawMaterialsList.splice(index, 1);
      let total = 0;
      this.RawMaterialsList.map((x) => {
        total += x.ii_total_amount;
      });
      this.InvoiceDetails.i_total_amount = total;
    },
    QuantityValidation: function () {
      let count = 0;

      this.RawMaterialsList.map((x) => {
        if (x.ii_qty && String(x.ii_qty).length == 0) {
          count++;
        }
      });

      if (count > 0) {
        return true;
      } else {
        return false;
      }
    },
    onFinalSubmit: function () {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (this.QuantityValidation()) {
          return;
        }
        if (valid) {
          let loader = this.$loading.show();

          this.btenable = true;
          let payload = {
            ...this.InvoiceDetails,
            VendorsList: this.RawMaterialsList,
          };
          console.log("this.payload :", payload);
          PosFnbService.AddInvoice(payload)
            .then((response) => {
              this.btenable = false;
              loader.hide();
              const { data } = response;
              if (data && data.status) {
                this.$router.push({
                  path: "/fnb/invoice",
                });
                this.$toasted.show(data.message);
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/InvoiceComponents/addInvoice.vue